import { Box, BoxProps, chakra } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';

const fade = keyframes`
  0% {
    opacity: 0
  }
  100% {
    opacity: 1
  }
`;

const scale = keyframes`
  0%, 100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
`;

export const TransferErrorIcon = (boxProps: BoxProps) => (
  <Box {...boxProps}>
    <chakra.svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 196 196"
      fill="none"
      animation={`${scale} .3s ease-in-out .9s both;`}
    >
      <defs>
        <linearGradient
          id="gradient"
          x1="-190.736"
          y1="-110.724"
          x2="294.551"
          y2="241.23"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D7EC4" />
          <stop offset="0.166667" stopColor="#139EDD" />
          <stop offset="0.317708" stopColor="#BBDBFF" />
          <stop offset="0.484375" stopColor="#FEA514" />
          <stop offset="0.583333" stopColor="#FF4539" />
          <stop offset="0.6875" stopColor="#FF5544" />
          <stop offset="0.8125" stopColor="#FF6A9A" />
          <stop offset="0.895833" stopColor="#BBDBFF" />
          <stop offset="1" stopColor="#0D7EC4" />
        </linearGradient>
      </defs>

      <chakra.path
        animation={`${fade} 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards`}
        fillRule="evenodd"
        clipRule="evenodd"
        fill="url(#gradient)"
        opacity={0}
        d="M98.4085 84.7574L14.3967 0.739243L0.912109 14.2228L84.9239 98.241L0.912973 182.246L14.3966 195.73L98.4075 111.726L182.003 195.328L195.488 181.844L111.892 98.242L195.502 14.6388L182.018 1.15425L98.4085 84.7574Z"
      />
    </chakra.svg>
  </Box>
);
